import { refinementList, searchBox, pagination, stats, configure, rangeInput, toggleRefinement } from "instantsearch.js/es/widgets"
import { connectHits } from "instantsearch.js/es/connectors"
import { initIndex, customClearRefinements, refinementCssClasses, rangeInputCssClasses } from "./Algolia.js"
import { createInsightsMiddleware } from "instantsearch.js/es/middlewares"

/* DESTINATION FILTERING */
const rfpEls = document.querySelectorAll(
    "[data-rfps]"
)
if (rfpEls.length) {

    /**
     * Generate a list of the current year plus 15
     * @returns
     */
    function generateYearRange(maxYears = 15) {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = 0; i <= maxYears; i++) {
            years.push(currentYear + i);
        }
        return years;
    }

    const siteSearch = initIndex(() => {
        return {
            refinementList: {
                bidStatus: ['Accepting proposals'],
                year: generateYearRange()
            }
        }
    });

    const insightsMiddleware = createInsightsMiddleware({
        insightsClient: window.aa,
        insightsInitParams: {
            useCookie: false
        },
        onEvent: (event, aa) => {
            const { insightsMethod, payload, widgetType, eventType } = event;

            // Send the event to Algolia
            if (insightsMethod) {

                if (eventType === "view") {
                    payload.eventName = 'Item Viewed from RFP Search';
                }
                if (eventType === "click") {
                    payload.eventName = "Item Selected from RFP Search";
                }

                aa(insightsMethod, payload);
            }

        }
    });

    siteSearch.use(insightsMiddleware);

    const renderHits = (renderOptions, isFirstRender) => {
        const { hits, widgetParams } = renderOptions;

        widgetParams.container.innerHTML = `
            <div class="row row-cols-1">
          ${hits
                .map(
                    item =>
                        `
                        <div class="col-lg-6 col-12 mb-3 d-flex align-items-stretch">
                            <div class="card" style="width: 100%">
                               
                                <div class="card-body">
                                    <h4 class="mt-0">
                                        <a href="${item.uri}" target="_blank">${item.name}</a>
                                    </h4>
                                   
                                    <div class="badge bg-info">${item.bidStatus}</div>

                                    <hr class="bg-dark-lighten my-3">
                              
                                    <p class="card-text d-flex justify-content-between">
                                        <span class="fw-semibold">
                                            <a href="${item.organizationUri}" target="_blank">${item.organization ?? ""}</a>
                                        </span>
                                        <span>${item.addressState ?? ""}</span>
                                    </p>

                                    ${(item.sports ? Object.keys(item.sports).map(function (key) {
                                        return "<span class='badge bg-info me-1'>" + item.sports[key] + "</span>";
                                    }) : []).join("")}

                                </div>
                            </div>
                      </div>`
                )
                .join("")}
            </div>
                </div>
      `;
    };
    const customHits = connectHits(
        renderHits
    );

    const monthOrder = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const rightsFeeRangeOrder = ['$0 - $1000', '$1000 - $5000', '$5000 - $10000', '$10000+'];
    
    siteSearch.addWidgets(
        [
            customClearRefinements({
                container: document.querySelector("#clear-refinements")
            }),

            searchBox({
                container: "#searchbox",
                showReset: false,
                cssClasses: {
                    form: "input-group",
                    input: "form-control",
                    submit: "btn btn-icon",
                    reset: "btn btn-icon"
                }
            }),
            refinementList({
                container: document.querySelector("#refinement-space-type"),
                attribute: "facilitySpaceType",
                limit: 10,
                showMore: true,
                showMoreLimit: 50,
                sortBy: ["name:asc"],
                cssClasses: refinementCssClasses
            }),
            refinementList({
                container: document.querySelector("#refinement-year"),
                attribute: "year",
                limit: 10,
                showMore: true,
                showMoreLimit: 50,
                sortBy: ["name:asc"],
                cssClasses: refinementCssClasses
            }),
            refinementList({
                container: document.querySelector("#refinement-month"),
                attribute: "month",
                limit: 5,
                showMore: true,
                sortBy: function (a, b) {
                    return monthOrder.indexOf(a.name) - monthOrder.indexOf(b.name);
                },
                cssClasses: refinementCssClasses
            }),
            refinementList({
                container: document.querySelector("#refinement-age-level"),
                attribute: "athleteAgeLevel",
                limit: 5,
                showMore: true,
                showMoreLimit: 50,
                //sortBy: ["name:asc"],
                cssClasses: refinementCssClasses
            }),
            refinementList({
                container: document.querySelector("#refinement-bid-status"),
                attribute: "bidStatus",
                limit: 5,
                sortBy: ["name:asc"],
                cssClasses: refinementCssClasses
            }),
            refinementList({
                container: document.querySelector("#refinement-region"),
                attribute: "region",
                limit: 20,
                sortBy: ["name:asc"],
                cssClasses: refinementCssClasses
            }),
            //numericMenu({
            //    container: document.querySelector("#refinement-room-nights"),
            //    attribute: "totalRoomNights",
            //    items: [
            //        { label: "All" },
            //        { label: "Less than 500", end: 500 },
            //        { label: "Between 500 - 1000", start: 500, end: 1000 },
            //        { label: "More than 1000", start: 1000 }
            //    ],
            //}),
            rangeInput({
                container: document.querySelector("#refinement-room-nights"),
                attribute: "totalRoomNights",
                cssClasses: rangeInputCssClasses
            }),
            refinementList({
                container: document.querySelector("#refinement-length-stay"),
                attribute: "averageLengthOfStayNights",
                limit: 5,
                showMore: true,
                showMoreLimit: 50,
                sortBy: ["name:desc"],
                cssClasses: refinementCssClasses
            }),
            toggleRefinement({
                container: document.querySelector("#refinement-rights-fee"),
                attribute: "hasRightsFee",
                on: 1,
                templates: {
                    labelText({ count }, { html }) {
                        return html`Yes`;
                    }
                },
                cssClasses: {
                    root: "px-3",
                    labelText: "p-1",
                },
            }),
            refinementList({
                container: document.querySelector("#refinement-rights-fee-range"),
                attribute: "rightsFeeRange",
                limit: 5,
                sortBy: function (a, b) {
                    return rightsFeeRangeOrder.indexOf(a.name) - rightsFeeRangeOrder.indexOf(b.name);
                },
                showMore: true,
                showMoreLimit: 50,
                cssClasses: refinementCssClasses
            }),
            customHits(
                {
                    container: document.querySelector("#hits")
                }
            ),
            pagination({
                container: "#pagination",
                cssClasses: {
                    list: "pagination",
                    item: "page-item",
                    link: "page-link",
                    disabledItem: "page-item disabled",
                    selectedItem: "page-item active"
                },
            }),
            stats({
                container: "#stats",
            }),
            configure({
                //hitsPerPage: 8,
                enablePersonalization: true,
                filters: "recordType:EventRfp AND NOT bidStatus:Archived"
            })
        ]
    );

    siteSearch.start();
}